import { CustomAttr } from "@turizi/shared";
import ShowSelfAttr from "./show-self-attr";
import { useMemo } from "react";

interface ShowSelfAttrProps {
    attrs: CustomAttr[];
    context?: any;
    size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg';
    className?: string;
    include?: string[];
    exclude?: string[];
    showkey?: boolean;
}

export default function ShowSelfAttrs({
    attrs = [],
    context,
    size = 'sm',
    className,
    include = [],
    exclude = [],
    showkey = true
}: ShowSelfAttrProps) {
    const filteredAttrs = useMemo(() => {
        return attrs
            .filter(attr => attr.value)
            .filter(attr => include.length === 0 || include.includes(attr.key) || include.includes(attr.key?.split('#')?.[0]))
            .filter(attr => exclude.length === 0 || (!exclude.includes(attr.key) && !exclude.includes(attr.key?.split('#')?.[0])))
            .sort((a, b) => a?.sort - b?.sort);
    }, [attrs, include, exclude]);

    if (filteredAttrs.length === 0) return null;

    return (
        <div className={className || 'flex flex-wrap gap-1'}>
            {filteredAttrs.map((attr: CustomAttr, index: number) => (
                <div key={index}>
                    <ShowSelfAttr attr={attr} context={context} size={size} showkey={showkey} />
                </div>
            ))}
        </div>
    );
}